"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _task = require("@/api/task");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserTaskDaily',
  data: function data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 任务表格数据
      dailyList: [],
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page: 1,
        limit: 10,
        userId: undefined,
        taskName: undefined,
        startDate: undefined,
        endDate: undefined
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    /** 查询任务列表 */getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _task.getUserTaskDailyList)(this.queryParams).then(function (res) {
        console.log('API返回数据：', res);
        _this.dailyList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.$message.error('获取数据失败');
        _this.loading = false;
      });
    },
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 日期范围变化 */handleDateRangeChange: function handleDateRangeChange(val) {
      if (val) {
        this.queryParams.startDate = val[0];
        this.queryParams.endDate = val[1];
      } else {
        this.queryParams.startDate = undefined;
        this.queryParams.endDate = undefined;
      }
    },
    /** 重置按钮操作 */resetQuery: function resetQuery() {
      this.dateRange = [];
      this.queryParams.userId = undefined;
      this.queryParams.taskName = undefined;
      this.queryParams.startDate = undefined;
      this.queryParams.endDate = undefined;
      this.handleQuery();
    }
  }
};